/**
 * web/src/lib/sanitize.ts
 * HTML sanitization for the one surface where the app injects rich HTML into
 * the DOM: the email gate preview/editor (EmailPreview). The welcome/ops email
 * bodies are HTML rendered from HubSpot deal data through Jinja templates and
 * can be edited by reviewers, so we run them through DOMPurify before every
 * innerHTML write AND on read-back from the contentEditable editor (F24). This
 * strips <script>, event-handler attributes (onerror/onclick/...), and
 * javascript:/data: URL schemes while preserving the formatting and links a
 * reviewer expects to see.
 */
import DOMPurify from 'dompurify';

/**
 * Sanitizes an email-body HTML string for safe rendering and editing. Removes
 * active content (scripts, event handlers, dangerous URL schemes); keeps
 * standard formatting + links. Safe for both innerHTML writes and
 * contentEditable read-back.
 *
 * @param html raw HTML (possibly hostile, possibly null/undefined)
 * @returns sanitized HTML string
 * @sideEffects none
 * @idempotent yes — sanitizing already-clean HTML returns equivalent HTML
 */
export function sanitizeEmailHtml(html: string | null | undefined): string {
  return DOMPurify.sanitize(html ?? '');
}
